import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CompleteOrderModule } from '@complete-order/complete-order.module';
import { SharedModule } from '@shared/shared.module';

import { FormsModule } from '@angular/forms';
import { DgxComponentsButtonModule } from '@domgen/dgx-fe-components/button';
import { DgxComponentsIconModule } from '@domgen/dgx-fe-components/icon';
import { DgxQmModule } from '@domgen/dgx-fe-qm';
import * as fromComponents from './components';
import * as fromContainers from './containers';

@NgModule({
  declarations: [...fromComponents.components, ...fromContainers.containers],
  imports: [
    CommonModule,
    SharedModule,
    CompleteOrderModule,
    DgxComponentsIconModule,
    DgxQmModule.forRoot(),
    DgxComponentsButtonModule,
    FormsModule,
  ],
  exports: [...fromComponents.components, ...fromContainers.containers],
})
export class ConfirmationModule {}
